import { AuraBaseTokenSections } from '@primeuix/themes/aura/base';

export const primitiveTokens: AuraBaseTokenSections.Primitive = {
  borderRadius: {
    none: '0',
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
  },
  gray: {
    50: '#f9fafb',
    100: '#f2f4f7',
    200: '#eaecf0',
    300: '#d0d5dd',
    400: '#98a2b3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#182230',
    900: '#101828',
    950: '#0c111d',
  },
  indigo: {
    50: '#EEECFF',
    100: '#C9C5FF',
    200: '#AFA9FF',
    300: '#8B82FF',
    400: '#756AFF',
    500: '#5245FF',
    600: '#4B3FE8',
    700: '#3A31B5',
    800: '#2D268C',
    900: '#221D6B',
    950: '#141140',
  },
  red: {
    50: '#FEF3F2',
    100: '#FEE4E2',
    200: '#FECDCA',
    300: '#FDA29B',
    400: '#FDA29B',
    500: '#F04438',
    600: '#D92D20',
    700: '#B42318',
    800: '#912018',
    900: '#7A271A',
    950: '#55160C',
  },
  orange: {
    50: '#FFFAEB',
    100: '#FEF0C7',
    200: '#FEDF89',
    300: '#FEC84B',
    400: '#FDB022',
    500: '#F79009',
    600: '#DC6803',
    700: '#B54708',
    800: '#93370D',
    900: '#7A2E0E',
    950: '#4E1D09',
  },
  green: {
    50: '#ECFDF3',
    100: '#DCFAE6',
    200: '#ABEFC6',
    300: '#75E0A7',
    400: '#47CD89',
    500: '#17B26A',
    600: '#079455',
    700: '#067647',
    800: '#085D3A',
    900: '#074D31',
    950: '#053321',
  },
  violet: {
    50: '#EEE4FF',
    100: '#DECAFF',
    200: '#AF93DE',
    300: '#8A62CF',
    400: '#7444C6',
    500: '#5115B8',
    600: '#4A13A7',
    700: '#33067F',
    800: '#2D0C65',
    900: '#22094D',
    950: '#180636',
  },
  slate: {
    50: '#F9FAFB',
    100: '#F2F4F7',
    200: '#EAECF0',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#182230',
    900: '#101828',
    950: '#0C111D',
  },
};
